export function getView(realDate, estimatedDate) {
  return estimatedDate && !realDate
}
